export default "__VITE_ASSET__Dy1pIk8l__"